<ul class="nav nav-tabs">
  <ng-container *ngFor="let tab of tiposDocumentosTabs">
    <li class="nav-item" *ngIf="tab.key !== 'Mascota' || consulta?.sub_spe_id == 59">
      <a class="nav-link" [ngClass]="{ 'active': selectedTab === tab.key && selectedView === 'consulta' }"
        href="javascript:void(0)" (click)="onTabClick(tab.key)" style="display: flex; align-items: center;">
        <i [class]="tab.icon" class=""></i>
        {{ tab.key }}
      </a>
    </li>
  </ng-container>
</ul>

<div class="col" *ngIf="(!documentos || isLoading) && selectedView === 'consulta'" style="min-height: 40px;">
  <div class="loader">
    <div class="loader__figure"></div>
    <p class="loader__label"></p>
  </div>
</div>

<ng-container *ngIf="documentos && !isLoading">
  <div class="tab-content w-100 mt-3" *ngIf="documentos && !isLoading && selectedView === 'consulta'"
    [ngSwitch]="selectedTab">

    <!-- ANAMNESIS -->
    <ng-container *ngSwitchCase="'Anamnesis'">
      <div>

        <div class="text-center mb-2"
          *ngIf="(anamnesisGuardadas?.length === 0) && !editandoAnamnesis && !agregandoAnamnesis">
        </div>

        <div class="card p-3 m-0" *ngIf="(anamnesisGuardadas?.length === 0) || editandoAnamnesis || agregandoAnamnesis">

          <label class="label-form font-weight-bold mb-2">
            <i class="fi fi-rr-stethoscope" style="font-size: medium;"></i>
            <span>Anamnesis</span>
          </label>

          <!-- textarea con label arriba -->
          <div class="field-top mb-3">
            <label class="field-top__label">Ingrese anamnesis</label>
            <textarea class="form-control" rows="3" [(ngModel)]="anamnesisText" placeholder=""></textarea>
          </div>

          <ng-container *ngIf="editandoAnamnesis">
            <div class="field-top mb-3">
              <label class="field-top__label">Motivo de modificación</label>
              <select class="form-control" name="id_causal" [(ngModel)]="id_causal">
                <option value="" selected disabled>Seleccionar motivo</option>
                <option *ngFor="let causal of causales.causales" [value]="causal.cau_id">
                  {{ causal.cau_description }}
                </option>
              </select>
            </div>
          </ng-container>

          <div class="text-right">
            <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarAnamnesis()">Cancelar</button>
            <button class="btn btn-guardar px-4" (click)="guardarAnamnesis()">Guardar cambios</button>
          </div>
        </div>

        <ng-container *ngIf="!editandoAnamnesis && !agregandoAnamnesis">
          <div *ngFor="let item of anamnesisGuardadas" class="card p-3 m-0 mb-2" style="height: auto;">
            <div class="title-card d-flex justify-content-between">
              <div class="col p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-stethoscope"></i>
                  <span>Anamnesis</span>
                </label>
              </div>
              <div class="col p-0 d-flex justify-content-end">
                <i class="fi fi-rr-pencil cursor-pointer" (click)="editarAnamnesis(item)"></i>
              </div>
            </div>

            <div class="col-12 p-0 recetas">
              <h6 class="my-2"
                style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
                <i class="d-flex fi fi-rr-calendar"></i>
                {{ item.med_con_his_date_attention}} - {{item.med_con_his_date_attention1 | date: 'hh:mm'}} horas
              </h6>
              <p class="mb-1">{{ item.med_con_his_anamnesis }}</p>
            </div>
          </div>
        </ng-container>

      </div>
    </ng-container>

    <!-- DIAGNÓSTICOS E INDICACIONES -->
    <ng-container *ngSwitchCase="'Diagnósticos e indicaciones'">
      <div>

        <div class="text-center mb-2" *ngIf="!editandoDiagnosticos && !agregandoDiagnostico">
          <button *ngIf="agregandoDiagnostico || diagnosticosGuardados?.length > 0" type="button" class="chip-add"
            (click)="abrirAgregarDiagnostico()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <div class="card p-3 m-0"
          *ngIf="editandoDiagnosticos || agregandoDiagnostico || diagnosticosGuardados?.length === 0">

          <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-doctor"></i>
            <span>Diagnóstico</span>
          </label>

          <div class="field-top mb-3">
            <label class="field-top__label">Ingrese diagnóstico</label>
            <textarea class="form-control" rows="3" [(ngModel)]="detalleDiagnostico" placeholder=""></textarea>
          </div>

          <!-- <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-doctor"></i>
            <span>Indicaciones:</span>
          </label> -->

          <div class="field-top mb-3">
            <label class="field-top__label">Ingrese indicaciones</label>
            <textarea class="form-control" rows="3" [(ngModel)]="indicacionDiagnostico" placeholder=""></textarea>
          </div>

          <!-- <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-document"></i>
            <span>Diagnóstico CIE-10:</span>
          </label> -->

          <!-- ng2-completer: se envuelve con field-top -->
          <div class="field-top mb-3">
            <label class="field-top__label">Seleccione diagnóstico CIE-10</label>
            <ng2-completer name="id_diagnostico" (selected)="changeDiagnostico($event)" [initialValue]="searchStrDia"
              [textNoResults]="'Dianóstico no encontrado'" [datasource]="diagnosticos" [(ngModel)]="searchStrDia"
              [minSearchLength]="3" [placeholder]="'Ingrese un minimo de 3 caracteres'" #id_diagnostico="ngModel"
              [autoMatch]="true" [inputClass]="'form-control'" [clearUnselected]="true" [openOnFocus]="true">
            </ng2-completer>
          </div>

          <ng-container *ngIf="editandoDiagnosticos">
            <div class="field-top mb-3">
              <label class="field-top__label">Motivo de modificación</label>
              <select class="form-control" name="id_causal" [(ngModel)]="id_causal">
                <option value="" selected disabled>Seleccionar motivo</option>
                <option *ngFor="let causal of causales.causales" [value]="causal.cau_id">
                  {{ causal.cau_description }}
                </option>
              </select>
            </div>
          </ng-container>

          <div class="text-right">
            <button class="btn btn-cancelar mr-2" (click)="cancelarDiagnostico()">Cancelar</button>
            <button class="btn btn-guardar px-4" (click)="guardarDiagnosticos()">Guardar cambios</button>
          </div>
        </div>

        <!-- Lista (sin cambios) -->
        <div class="col-12 p-0 recetas"
          *ngIf="diagnosticosGuardados.length > 0 && !editandoDiagnosticos && !agregandoDiagnostico">
          <div class="card p-3 m-0 mb-2" style="height: auto;" *ngFor="let file of diagnosticosGuardados">
            <div class="title-card d-flex justify-content-between">
              <div class="col-8 p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-doctor"></i>
                  <span>Diagnóstico</span>
                </label>
              </div>
              <div class="col-4 p-0 d-flex justify-content-end" style="gap: 5px;">
                <i class="fi fi-rr-pencil cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="editarDiagnostico(file)"></i>
                <i class="fi fi-rr-trash cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="abrirModalEliminar(file, 'diagnostico')"></i>
                <i class="fi fi-rr-download cursor-pointer"
                  style="display: flex; align-items: center; font-size: small;"
                  (click)="_generalServices.descargarFileAtt(file.att_id, file.file_name_desc, null)"></i>
              </div>
            </div>

            <p *ngIf="file.dia_name" class="text-muted mb-0 mt-2" style="background-color: #316AD8;
                            width: fit-content;
                            padding: 2px 5px;
                            border-radius: 5px;
                            color: white !important;
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 100%;
                            gap: 5px;">
              <i class="fi fi-rr-doctor"></i>
              {{file.dia_cie10}}: {{file.dia_name}}
            </p>
            <h6 class="my-2"
              style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
              <i class="d-flex fi fi-rr-calendar"></i>
              <span>{{ file.diag_det_his_date }} - {{file.diag_det_his_date1 | date: 'hh:mm'}} horas</span>
            </h6>
            <p class="mb-1">{{ file.diag_det_his_diagnostic_detail }}</p>
            <p class="mb-1 font-italic text-muted">{{ file.diag_det_his_indication_detail }}</p>
          </div>
        </div>

      </div>
    </ng-container>

    <!-- RECETAS -->
    <!-- RECETAS -->
    <ng-container *ngSwitchCase="'Recetas'">
      <div>

        <!-- Botón "+ Agregar" -->
        <div class="text-center mb-2" *ngIf="!agregandoReceta && recetasGuardadas.length > 0">
          <button *ngIf="agregandoReceta || recetasGuardadas.length > 0" type="button" class="chip-add"
            (click)="abrirAgregarReceta()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <!-- Formulario -->
        <div class="card p-3 m-0" *ngIf="agregandoReceta || recetasGuardadas.length === 0">

          <label class="label-form mb-1">
            <i class="fi fi-rr-document-signed"></i>
            Tipo de receta:
          </label>

          <select class="form-control mb-3" [(ngModel)]="id_receta" name="id_receta" style="font-size: 14px;"
            (ngModelChange)="onChangeTipoReceta($event)">
            <option [ngValue]="''" disabled>Seleccione tipo</option>

            <option *ngFor="let receta of recetasFiltradas" [ngValue]="receta.pre_typ_id">
              {{ receta.pre_typ_name }}
            </option>
          </select>

          <!-- YAPP: solo visible si el tipo de receta corresponde -->
          <ng-container *ngIf="mostrarBuscadorYapp()">

            <div class="row">
              <div class="col-md-6">
                <label class="label-form mb-1">
                  <i class="fi fi-rr-map-marker"></i>
                  Región
                </label>

                <select class="form-control mb-2" [(ngModel)]="selectedRegionId" name="selectedRegionId"
                  (ngModelChange)="onRegionYappChange($event)">
                  <option [ngValue]="null" disabled>Seleccione región</option>
                  <option *ngFor="let region of regionesYapp" [ngValue]="region.reg_id">
                    {{ region.reg_name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label class="label-form mb-1">
                  <i class="fi fi-rr-map-marker-home"></i>
                  Comuna
                </label>

                <select class="form-control mb-2" [(ngModel)]="selectedComunaId" name="selectedComunaId"
                  [disabled]="!selectedRegionId" (ngModelChange)="onComunaYappChange($event)">
                  <option [ngValue]="null" disabled>Seleccione comuna</option>
                  <option *ngFor="let comuna of comunasYapp" [ngValue]="comuna.com_id">
                    {{ comuna.com_name }}
                  </option>
                </select>
                <p style="color: #67757c;">{{(selectedRegionId !== this.consulta.reg_id || selectedComunaId !==
                  this.consulta.com_id) ?'*Ubicación actual paciente': ''}}</p>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="label-form mb-0">
                <i class="fi fi-rr-search"></i>
                Busca un medicamento
              </label>

              <small class=" yapp-powered">Con tecnología de YAPP</small>
            </div>

            <div class="position-relative mb-3">
              <input type="text" class="form-control pr-5" placeholder="Busca un medicamento" [ngModel]="yappQuery"
                (ngModelChange)="onYappQueryChange($event)" />

              <div class="list-group yapp-dropdown" *ngIf="yappShowDropdown && yappResults?.length > 0">
                <button type="button" class="list-group-item list-group-item-action" *ngFor="let it of yappResults"
                  (click)="selectYappItem(it)" style="cursor:pointer;">
                  <div class="d-flex flex-column text-left">
                    <strong>{{ getYappItemTitle(it) }}</strong>
                    <small class="text-muted" *ngIf="getYappItemSubtitle(it)">
                      {{ getYappItemSubtitle(it) }}
                    </small>
                  </div>
                </button>
              </div>
            </div>

            <small class="text-muted d-block mb-2" *ngIf="yappLoading">
              Buscando...
            </small>

            <small class="text-muted d-block mb-2"
              *ngIf="!yappLoading && yappQuery?.length >= 2 && yappShowDropdown && yappResults?.length === 0">
              Sin resultados.
            </small>

            <div class="yapp-selected-box mb-3" *ngIf="yappSelectedItems.length > 0">
              <div class="yapp-selected-item" *ngFor="let med of yappSelectedItems; let i = index">
                <div class=" yapp-selected-header d-flex justify-content-between align-items-start">
                  <div class="row m-0 w-100">
                    <div class="col-1 p-0" style="display: flex; align-items: center; justify-content: flex-start;">
                      <i class="fi fi-rr-medicine"></i>
                    </div>
                    <div class="col-10 p-0">
                      <div class="yapp-selected-title">
                        {{ med.title }}
                      </div>
                      <div class="yapp-selected-subtitle" *ngIf="med.subtitle">
                        {{ med.subtitle }}
                      </div>
                    </div>
                    <div class="col-1 p-0" style="display: flex; justify-content: flex-end;">
                      <button type="button" class="btn btn-link p-0 yapp-delete-btn" (click)="removeYappItem(i)">
                        <i class="fi fi-rr-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="mt-2">
                  <input type="text" class="form-control" placeholder="Escribe las indicaciones" style="border: none;"
                    [(ngModel)]="med.indication" [name]="'indication_' + i">
                </div>
              </div>
            </div>
          </ng-container>

          <label class="label-form mb-1">
            Escribe un medicamento
          </label>

          <textarea class="form-control mb-3" rows="4" placeholder="Escribe la receta de forma libre aquí..."
            [(ngModel)]="prescriptionText"></textarea>

          <div *ngIf="usuario.doc_enrolled" class="form-check mb-3">
            <input id="checkbox-firma" class="form-check-input" type="checkbox" [(ngModel)]="check_firma"
              name="check_firma">
            <label for="checkbox-firma" class="form-check-label" style="font-size: 14px;">
              Enviar receta con firma electrónica avanzada
            </label>
          </div>

          <div class="text-right">
            <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarReceta()">Cancelar</button>
            <button class="btn btn-guardar px-4" (click)="postCreatePrescription()">Guardar cambios</button>
          </div>
        </div>

        <!-- Lista guardada -->
        <div class="col-12 p-0 recetas" *ngIf="recetasGuardadas.length > 0 && !agregandoReceta">
          <div class="card p-3 m-0 mb-2" style="height: auto;" *ngFor="let item of recetasGuardadas">
            <div class="title-card d-flex justify-content-between">
              <div class="col-8 p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-document-signed"></i>
                  <span>Receta</span>
                </label>
              </div>
              <div class="col-4 p-0 d-flex justify-content-end" style="gap: 5px;">
                <i class="fi fi-rr-trash cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="abrirModalEliminar(item, 'receta')"></i>
                <i class="fi fi-rr-download cursor-pointer"
                  style="display: flex; align-items: center; font-size: small;"
                  (click)="_generalServices.descargarFileAtt(item.att_id, item.file_name_desc, null)"></i>
              </div>
            </div>

            <p class="text-muted mb-0 mt-2" style="background-color: #316AD8;
                        width: fit-content;
                        padding: 2px 5px;
                        border-radius: 5px;
                        color: white !important;
                        display: flex;
                        align-items: center;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 100%;
                        gap: 5px;">
              <i class="fi fi-rr-document-signed"></i>
              {{item.pre_typ_name}}
            </p>

            <h6 class="my-2"
              style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
              <i class="d-flex fi fi-rr-calendar"></i>
              <span>{{ item.pre_his_date}} - {{item.pre_his_date1 | date: 'HH:mm'}} horas</span>
            </h6>

            <p class="mb-1">{{ item.pre_his_indication }}</p>
          </div>
        </div>

      </div>
    </ng-container>



    <!-- CERTIFICADOS -->
    <ng-container *ngSwitchCase="'Certificados'">
      <div>

        <div class="text-center mb-2" *ngIf="!agregandoCertificado && !editandoCertificados">
          <button *ngIf="agregandoCertificado || certificadosGuardados.length > 0" type="button" class="chip-add"
            (click)="abrirAgregarCertificado()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <div class="card p-3 m-0"
          *ngIf="agregandoCertificado || editandoCertificados || certificadosGuardados.length === 0">

          <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-document"></i>
            <span class="m-0">Certificado</span>
          </label>

          <div class="field-top mb-3">
            <label class="field-top__label">Ingrese certificado médico</label>
            <textarea class="form-control" rows="3" [(ngModel)]="certificadosText" placeholder=""></textarea>
          </div>

          <ng-container *ngIf="editandoCertificados">
            <div class="field-top mb-3">
              <label class="field-top__label">Motivo de modificación</label>
              <select class="form-control" name="id_causal" [(ngModel)]="id_causal">
                <option value="" selected disabled>Seleccionar motivo</option>
                <option *ngFor="let causal of causales.causales" [value]="causal.cau_id">
                  {{causal.cau_description}}
                </option>
              </select>
            </div>
          </ng-container>

          <div class="text-right">
            <button class="btn btn-cancelar mr-2" (click)="cancelarCertificado()">Cancelar</button>
            <button class="btn btn-guardar px-4" (click)="guardarCertificado()">Guardar cambios</button>
          </div>
        </div>

        <!-- Lista sin cambios -->
        <div class="col-12 p-0 recetas"
          *ngIf="certificadosGuardados.length > 0 && !agregandoCertificado && !editandoCertificados">

          <div class="card p-3 m-0 mb-2" style="height: auto;" *ngFor="let item of certificadosGuardados">
            <div class="title-card d-flex justify-content-between">
              <div class="col-8 p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-document"></i>
                  <span>Certificado:</span>
                </label>
              </div>
              <div class="col-4 p-0 d-flex justify-content-end" style="gap: 5px;">
                <i class="fi fi-rr-pencil cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="editarCertificado(item)"></i>
                <i class="fi fi-rr-trash cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="abrirModalEliminar(item, 'certificado')"></i>
                <i class="fi fi-rr-download cursor-pointer"
                  style="display: flex; align-items: center; font-size: small;"
                  (click)="_generalServices.descargarFileAtt(item.att_id, item.file_name_desc, null)"></i>
              </div>
            </div>
            <h6 class="my-2"
              style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
              <i class="d-flex fi fi-rr-calendar"></i>
              <span>{{ item.med_ord_date}} - {{item.med_ord_date1 | date: 'HH:mm'}} horas</span>
            </h6>
            <p class="mb-1">{{ item.med_ord_his_comment }}</p>
          </div>

        </div>
      </div>
    </ng-container>

    <!-- ÓRDENES DE EXÁMENES -->
    <ng-container *ngSwitchCase="'Órdenes de exámenes'">
      <div>

        <div class="text-center mb-2" *ngIf="!agregandoOrden && !editandoOrdenes">
          <button *ngIf="agregandoOrden || ordenesGuardadas.length > 0" type="button" class="chip-add"
            (click)="abrirAgregarOrden()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <div class="card p-3 m-0" *ngIf="agregandoOrden || editandoOrdenes || ordenesGuardadas.length === 0">

          <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-document"></i>
            <span>Órden de exámen</span>
          </label>

          <div class="field-top mb-2" style="height: auto !important;">
            <label class="field-top__label">
              Seleccione tipo de exámen
            </label>
            <select class="form-control" [(ngModel)]="id_exam" name="id_exam" style="font-size: 14px;">
              <option value="" disabled selected>Seleccione examen</option>
              <option *ngFor="let examen of (examenes?.examenes || [])" [value]="examen.exa_typ_id">
                {{ examen.exa_typ_name }}
              </option>
            </select>
          </div>

          <div class="field-top mb-3">
            <label class="field-top__label">Ingrese orden de examen</label>
            <textarea class="form-control" rows="3" [(ngModel)]="ordersText" placeholder=""></textarea>
          </div>

          <ng-container *ngIf="editandoOrdenes">
            <div class="field-top mb-3">
              <label class="field-top__label">Motivo de modificación</label>
              <select class="form-control" name="id_causal" [(ngModel)]="id_causal">
                <option value="" selected disabled>Seleccionar motivo</option>
                <option *ngFor="let causal of causales.causales" [value]="causal.cau_id">
                  {{causal.cau_description}}
                </option>
              </select>
            </div>
          </ng-container>

          <div class="text-right">
            <button class="btn btn-cancelar mr-2" (click)="cancelarOrden()">Cancelar</button>
            <button class="btn btn-guardar px-4" (click)="guardarOrdenExamen()">Guardar cambios</button>
          </div>
        </div>

        <!-- Lista sin cambios -->
        <div class="col-12 p-0 recetas" *ngIf="ordenesGuardadas.length > 0 && !agregandoOrden && !editandoOrdenes">
          <div class="card p-3 m-0 mb-3" style="height: auto;" *ngFor="let item of ordenesGuardadas">
            <div class="title-card d-flex justify-content-between">
              <div class="col-8 p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-doctor"></i>
                  <span>Orden de exámenes</span>
                </label>
              </div>
              <div class="col-4 p-0 d-flex justify-content-end" style="gap: 5px;">
                <i class="fi fi-rr-pencil cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="editarOrdenExamen(item)"></i>
                <i class="fi fi-rr-trash cursor-pointer" style="display: flex; align-items: center; font-size: small;"
                  (click)="abrirModalEliminar(item, 'orden')"></i>
                <i class="fi fi-rr-download cursor-pointer"
                  style="display: flex; align-items: center; font-size: small;"
                  (click)="_generalServices.descargarFileAtt(item.att_id, item.file_name_desc, null)"></i>
              </div>
            </div>
            <p class="text-muted mb-0 mt-2" style="background-color: #316AD8;
                            width: fit-content;
                            padding: 2px 5px;
                            border-radius: 5px;
                            color: white !important;
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 100%;
                            gap: 5px;">
              <i class="fi fi-rr-document"></i>
              {{item.exa_typ_name}}
            </p>
            <h6 class="my-2"
              style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
              <i class="d-flex fi fi-rr-calendar"></i>
              <span>{{ item.med_ord_date}} - {{item.med_ord_date1 | date:'HH:mm'}} horas</span>
            </h6>
            <p class="mb-1">{{ item.med_ord_his_comment }}</p>
          </div>
        </div>

      </div>
    </ng-container>

    <!-- LICENCIAS -->
    <ng-container *ngSwitchCase="'Licencias'">
      <div>

        <div class="card p-3 m-0" *ngIf="agregandoLicencia ||  licenciasGuardadas.length === 0"
          style="max-height: calc(100vh - 438px);">

          <label class="label-form font-weight-bold mb-2 d-flex align-items: center;">
            <i class="fi fi-rr-document"></i>
            <span class="m-0">Licencia médica</span>
          </label>

          <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
            <label class="field-top__label">Diagnóstico</label>
            <select class="form-control" [(ngModel)]="licenciaDiagnosticoId" style="font-size: 14px;">
              <option value="" disabled selected>Seleccione diagnóstico</option>
              <option *ngFor="let d of diagnosticosParaLicencia" [value]="d.dia_det_id">
                {{ d.dia_name }}
              </option>
            </select>
          </div>

          <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
            <label class="field-top__label">Fecha de inicio de reposo</label>
            <input class="form-control" type="date" [(ngModel)]="licenciaFechaInicio" style="font-size: 14px;" />
          </div>

          <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
            <label class="field-top__label">Días de reposo</label>
            <input type="number" class="form-control" [(ngModel)]="licenciaDiasReposo" min="1"
              style="font-size: 14px;" />
          </div>

          <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
            <label class="field-top__label">Tipo de licencia</label>
            <select class="form-control" [(ngModel)]="licenciaTipo" style="font-size: 14px;">
              <option value="" disabled selected>Seleccione tipo</option>
              <option *ngFor="let t of tiposLicencia" [value]="t.med_lev_typ_id">
                {{ t.med_lev_typ_name }}
              </option>
            </select>
          </div>

          <div class="row" *ngIf="(licenciaTipo) === '4'">
            <div class="col-sm-6">
              <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
                <label class="field-top__label">RUT hijo (opcional)</label>
                <input class="form-control" [(ngModel)]="licenciaRutHijo" style="font-size: 14px;" />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="field-top mb-2" style="margin-bottom: .5rem !important; height: auto;">
                <label class="field-top__label">Fecha nacimiento hijo (opcional)</label>
                <input class="form-control" type="date" [(ngModel)]="licenciaFechaNacimientoHijo"
                  style="font-size: 14px;" />
              </div>
            </div>
          </div>

          <div class="text-right">
            <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarLicencia()">Cancelar</button>
            <button type="button" class="btn btn-guardar mr-2" (click)="solicitarLicencia()">Solicitar licencia</button>
            <button type="button" class="btn btn-guardar" *ngIf="usuario?.doc_lme" (click)="generarLicencia()">
              Generar licencia
            </button>
          </div>
        </div>

        <!-- Lista sin cambios -->
        <div class="col-12 p-0 recetas" *ngIf="licenciasGuardadas.length > 0 && !agregandoLicencia ">
          <div class="card p-3 m-0 mb-2" style="height: auto;" *ngFor="let item of licenciasGuardadas">
            <div class="title-card d-flex justify-content-between">
              <div class="col-8 p-0 d-flex align-items-center">
                <label class="font-weight-bold d-flex align-items-center mb-0">
                  <i class="fi fi-rr-doctor"></i>
                  <span>Licencia</span>
                </label>
              </div>
              <div class="col-4 p-0 d-flex justify-content-end">
                <button class="btn btn-sm btn-link text-danger m-0 p-0" *ngIf="item.att_id"
                  (click)="_generalServices.descargarFileAtt(item.att_id, item.file_name_desc, null)">
                  <mat-icon>file_download</mat-icon>
                </button>
              </div>
            </div>
            <h6 class="my-2"
              style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
              <i class="d-flex fi fi-rr-calendar"></i>
              <span>{{ item.med_lea_request_date}} - {{item.med_lea_request_date1 | date: 'HH:mm'}} horas</span>
            </h6>
            <ul class="mb-0 pl-3" style="font-size:13px; color:#6c757d;">
              <li>Diagnóstico: {{ item.dia_name }}</li>
              <li>
                <span
                  style="display: flow; max-width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                  Diagnóstico médico: {{ item.dia_det_diagnostic_detail }}
                </span>
              </li>
              <li>Fecha inicio de reposo: {{ item.med_lea_start_date | date:'dd/MM/yyyy' }}</li>
              <li>Días de reposo: {{ item.med_lea_days }}</li>
              <li>Tipo de licencia: {{ item.med_lev_typ_name }}</li>
            </ul>
          </div>
        </div>

      </div>
    </ng-container>

    <!-- OTROS DOCUMENTOS -->
    <ng-container *ngSwitchCase="'Otros documentos'">
      <div>

        <div class="text-center mb-2" *ngIf="!agregandoDocumento">
          <button type="button" class="chip-add" (click)="abrirAgregarDocumento()">
            <span class="plus">+</span> Agregar documento
          </button>
        </div>

        <div class="card p-3 m-0" style="height: auto;" [ngClass]="{ 'mb-2': agregandoDocumento }"
          *ngIf="agregandoDocumento">

          <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="d-flex fi fi-rr-clip"></i>
            <span>Adjuntar documento</span>
          </label>

          <div class="field-top mb-3">
            <label class="field-top__label">Título del documento</label>
            <input type="text" class="form-control" [(ngModel)]="nombre_doc" name="nombre_doc" placeholder=""
              maxlength="20" style="font-size: 14px;" />
          </div>

          <div class="mb-2">
            <label class="mb-1 d-block">Archivo (PDF, JPG o PNG) — máx. 20 MB</label>
            <input type="file" class="form-control-file" (change)="onFileSelected($event)" />
          </div>

          <div *ngIf="doc" class="mb-2">
            <div *ngIf="doc_permitido && !doc_supera_peso" class="row p-2 border rounded d-flex align-items-center">
              <div class="col-2 p-2">
                <i class="fi fi-rr-document" style="font-size:large;"></i>
              </div>
              <div class="col-8 p-0">
                <div class="flex-grow-1">
                  <div class="font-weight-bold">{{ doc.name }}</div>
                  <small>{{ (doc.size/1024/1024) | number:'1.0-2' }} MB</small>
                </div>
              </div>
              <div class="col-2 d-flex justify-content-end p-0">
                <button type="button" class="btn btn-sm btn-link text-danger cursor-pointer"
                  (click)="delFileSelected()">
                  <i class="fi fi-rr-trash" style="font-size: large;"></i>
                </button>
              </div>
            </div>

            <div *ngIf="doc_supera_peso" class="alert alert-warning mt-2 mb-0">
              El documento supera el máximo permitido (20 MB).
            </div>
            <div *ngIf="!doc_permitido" class="alert alert-warning mt-2 mb-0">
              Solo se permite PDF, JPG o PNG.
            </div>
          </div>

          <div class="text-right mt-3">
            <button class="btn btn-cancelar mr-2" (click)="cancelarDocumento()">Cancelar</button>
            <button class="btn btn-guardar px-4" [disabled]="!puedeGuardarDocumento()" (click)="guardarDocumento()">
              Subir documento
            </button>
          </div>
        </div>

        <!-- LISTA / TABLA sin cambios -->
        <div class="mt-3">
          <div *ngIf="archivos_consulta.length === 0" class="font-weight-bold mb-2">Documentos de esta consulta</div>

          <div *ngIf="(!archivos_consulta || archivos_consulta.length === 0)" class="text-muted">
            No existen documentos adjuntos en esta consulta.
          </div>

          <div class="table-responsive" style="padding: 10px; background: white; border-radius: 6px;"
            *ngIf="archivos_consulta?.length">
            <table class="table table-sm custom-table m-0" style="background: white;">
              <thead class="thead-alma">
                <tr>
                  <th>Nombre</th>
                  <th class="d-none d-md-table-cell">Fecha</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of archivos_consulta; let i = index" [ngClass]="{ 'row-alt': (i % 2 === 1) }">
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="fi fi-rr-document"></i>
                      </div>

                      <div class="nombre-doc ml-2">
                        <div class="nombre-principal">
                          {{ item.nameFile || item.file_name_desc || item.file_name || 'OTROS DOCUMENTOS' }}
                        </div>

                        <!-- <div class="nombre-secundario">
                        {{ (item.tipo_doc || item.att_typ_name || 'Documento adjunto') | titlecase }}
                      </div> -->

                        <div class="fecha-mobile d-block d-md-none text-muted">
                          {{ item.att_date | date:'dd/MM/yyyy' }}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td class="align-middle d-none d-md-table-cell">
                    {{ item.att_date | date:'dd/MM/yyyy' }}
                  </td>

                  <td class="align-middle">
                    <div class="col" style="padding: 0; display: flex; gap: 10px;">
                      <i class="fi fi-rr-download cursor-pointer" (click)="_generalServices.descargarFileAtt(
                      item.att_id,
                      item.file_name_desc || item.file_name || item.nameFile,
                      null
                    )"></i>
                      <i class="fi fi-rr-trash cursor-pointer" (click)="abrirModalEliminar(item, 'otro')"></i>
                    </div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>

      </div>
    </ng-container>



    <!-- MASCOTA -->
    <ng-container  *ngSwitchCase="'Mascota'">
      <div *ngIf="consulta.sub_spe_id == 72 || consulta.spe_name=='Veterinaria'">

        <div class="text-center mb-2" *ngIf="!agregandoMascota && mascotasGuardadas.length > 0">
          <button type="button" class="chip-add" (click)="abrirAgregarMascota()">
            <span class="plus">+</span> Agregar
          </button>
        </div>

        <div class="card p-3 m-0" *ngIf="agregandoMascota || editandoMascota || mascotasGuardadas.length === 0">
          <label class="label-form font-weight-bold mb-2 d-flex align-items-center">
            <i class="fi fi-rr-paw"></i>
            <span>Mascota</span>
          </label>

          <div class="row">
            <div class="col-md-12">
              <!-- <div class="field-top "> -->
              <label class="field-top__label">Nombre paciente *</label>
              <input type="text" class="form-control" [(ngModel)]="mascotaNombrePaciente" name="mascotaNombrePaciente"
                placeholder="Ej: Firulais" />
              <!-- </div> -->
            </div>

          </div>

          <div class="row">
            <div class="col-md-6">
              <!-- <div class="field-top"> -->
              <label class="field-top__label">Edad *</label>
              <input type="text" class="form-control" [(ngModel)]="mascotaEdad" name="mascotaEdad"
                placeholder="Ej: 5 años" />
              <!-- </div> -->
            </div>
            <div class="col-md-6">
              <!-- <div class="field-top mb-3"> -->
              <label class="field-top__label">Especie *</label>
              <input type="text" class="form-control" [(ngModel)]="mascotaEspecie" name="mascotaEspecie"
                placeholder="Ej: Canino" />
              <!-- </div> -->
            </div>

            <div class="col-md-6">
              <!-- <div class="field-top mb-3"> -->
              <label class="field-top__label">Raza *</label>
              <input type="text" class="form-control" [(ngModel)]="mascotaRaza" name="mascotaRaza"
                placeholder="Ej: Pastor Alemán" />
              <!-- </div> -->
            </div>
            <div class="col-md-6">
              <!-- <div class="field-top mb-3"> -->
              <label class="field-top__label">Peso *</label>
              <input type="text" class="form-control" [(ngModel)]="mascotaPeso" name="mascotaPeso"
                placeholder="Ej: 12 kg" />
              <!-- </div> -->
            </div>
          </div>

          <div class="row">

            <div class="col-md-6">
              <!-- <div class="field-top mb-3"> -->
              <label class="field-top__label">Sexo *</label>
              <select class="form-control" [(ngModel)]="mascotaSexo" name="mascotaSexo">
                <option [ngValue]="''" disabled>Seleccione sexo</option>
                <option [ngValue]="'Macho'">Macho</option>
                <option [ngValue]="'Hembra'">Hembra</option>
              </select>
              <!-- </div> -->
            </div>

            <div class="col-md-6">
              <!-- <div class="field-top mb-3"> -->
              <label class="field-top__label">Esterilizado *</label>
              <select class="form-control" [(ngModel)]="mascotaEsterilizado" name="mascotaEsterilizado">
                <option [ngValue]="''" disabled>Seleccione opción</option>
                <option [ngValue]="'Sí'">Sí</option>
                <option [ngValue]="'No'">No</option>
              </select>
              <!-- </div> -->
            </div>

            <div class="col-md-12">
              <div class="field-top mb-3">
                <label class="field-top__label">Comentario</label>
                <textarea class="form-control" rows="3" [(ngModel)]="mascotaComentario" placeholder=""></textarea>
              </div>
            </div>
          </div>

          <ng-container *ngIf="editandoMascota">
            <div class="field-top mb-3">
              <label class="field-top__label">Motivo de modificación</label>
              <select class="form-control" name="id_causal_mascota" [(ngModel)]="id_causal">
                <option value="" selected disabled>Seleccionar motivo</option>
                <option *ngFor="let causal of causales.causales" [value]="causal.cau_id">
                  {{ causal.cau_description }}
                </option>
              </select>
            </div>
          </ng-container>

          <div class="text-right">
            <button type="button" class="btn btn-cancelar mr-2" (click)="cancelarMascota()">Cancelar</button>
            <button type="button" class="btn btn-guardar px-4" (click)="guardarMascota()">Guardar cambios</button>
          </div>
        </div>

        <div class="col-12 p-0 recetas" *ngIf="mascotasGuardadas.length > 0 && !agregandoMascota && !editandoMascota">
  <div class="card p-3 m-0 mb-2" style="height: auto;" *ngFor="let item of mascotasGuardadas">
    <div class="title-card d-flex justify-content-between">
      <div class="col-8 p-0 d-flex align-items-center">
        <label class="font-weight-bold d-flex align-items-center mb-0">
          <i class="fi fi-rr-paw"></i>
          <span>Mascota</span>
        </label>
      </div>

      <div class="col-4 p-0 d-flex justify-content-end" style="gap: 5px;">
        <i class="fi fi-rr-pencil cursor-pointer"
          style="display: flex; align-items: center; font-size: small;"
          (click)="editarMascota(item)"></i>

        <i class="fi fi-rr-trash cursor-pointer"
          style="display: flex; align-items: center; font-size: small;"
          (click)="abrirModalEliminar(item, 'mascota')"></i>

        <i class="fi fi-rr-download cursor-pointer"
          style="display: flex; align-items: center; font-size: small;"
          (click)="_generalServices.descargarFileAtt(item.att_id, item.file_name_desc || item.file_name, null)"></i>
      </div>
    </div>

    <h6 class="my-2"
      style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
      <i class="d-flex fi fi-rr-calendar"></i>
      <span>{{ item.doc_masc_date }} - {{ item.att_date | date: 'HH:mm' }} horas</span>
    </h6>

    <ul class="mb-0 pl-3" style="font-size:13px; color:#6c757d;">
      <li>Nombre mascota: {{ item.doc_masc_nombre_mascota || '—' }}</li>
      <li>Edad: {{ item.doc_masc_edad || '—' }}</li>
      <li>Especie: {{ item.doc_masc_especie || '—' }}</li>
      <li>Raza: {{ item.doc_masc_raza || '—' }}</li>
      <li>Sexo: {{ item.doc_masc_sexo || '—' }}</li>
      <li>Peso: {{ item.doc_masc_peso || '—' }}</li>
      <li>Esterilizado: {{ item.doc_masc_esterilizado || '—' }}</li>
      <li>Comentario: {{ item.doc_masc_his_comment || '—' }}</li>
    </ul>
  </div>
</div>

      </div>
    </ng-container>
  </div>
</ng-container>

<!-- MODALES -->
<div class="modal-backdrop-common" *ngIf="modalActual === 'confirmacionEliminar'" (click)="cerrarModal()">
  <div class="modal-common-content" (click)="$event.stopPropagation()">
    <h2 class="modal-title">¿Está seguro que desea eliminar este documento?</h2>
    <p class="modal-reason"></p>

    <div class="buttons-box row mt-3">
      <div class="col">
        <button mat-button class="btn-secondary" style="line-height: 36px;" (click)="cerrarModal()">
          <p class="m-0" style="font-weight: 600; line-height: inherit;">Cancelar</p>
        </button>
      </div>
      <div class="col">
        <button mat-raised-button class="btn-primary-cancel"
          style="line-height: 36px; border: 2px solid #0e0087 !important;" (click)="eliminarDocumento()">
          <p class="m-0" style="font-weight: 600; line-height: inherit;">Aceptar</p>
        </button>
      </div>
    </div>
  </div>
</div>